import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingService } from '../../services/loading.service';
import { BaseComponent } from '../base.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent extends BaseComponent implements OnInit, OnDestroy {

  year: number;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(private injector: Injector,
              private breakpointObserver: BreakpointObserver,
              private loadingService: LoadingService) {
    super(injector);
    this.year = new Date().getUTCFullYear() % 100;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  feedback() {
    this.dialogService.instance(ConfirmationDialogComponent, {
      title: 'dialog.title.feedback',
      message: 'dialog.message.feedback',
      btnCancel: 'dialog.action.close',
      btnOk: 'dialog.action.ok',
      btnOkStyle: 'button--green-primary',
      displayBtnOk: false
    }, { disableClose: true });
  }
}
